import './scripts/app';
import {initElements} from './define/shared';
const $ = jQuery;

$(() => {

    const headerEl = document.getElementById('masthead');
    pushContent();
    window.addEventListener('resize', pushContent);
    window.addEventListener('orientationchange', pushContent);

    function pushContent() {
        document.body.style.paddingTop = `${headerEl.offsetHeight + 30}px`;
    }

    initElements('.externalVideo', el => {
        const provider = el.dataset.videoProvider;
        const videoId = el.dataset.videoId;
        const previewBtn = el.querySelector('.externalVideo-preview');

        let iframeUrl = "";
        if (provider === "youtube") {
            iframeUrl = `https://youtube.com/embed/${videoId}`;
        }
        if (typeof $.fn.featherlight === 'function' && iframeUrl) {
            previewBtn.addEventListener("click", event => {
                event.preventDefault();
                $.featherlight(iframeUrl, {
                    type: "iframe",
                    iframeWidth: 960,
                    iframeHeight: 540,
                });
            });
        }
    });
});

